<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label for="examDate">
            <span class="required">*</span>
            {{ $t("labels.examDate") }}
          </label>
          <date-picker v-model="clonedExam.date" width="100%" format="DD/MM/YYYY" :lang="$i18n.locale"></date-picker>
        </div>
      </div>
      <div class="col-md-8">
        <div class="form-group">
          <label for="examType">
            <span class="required">*</span>
            {{ $t("labels.examType") }}
          </label>
          <select class="form-control"  @change="$emit('update:typeId',$event.target.value)">
            <option
              v-for="tp in clonedExamTypes"
              :value="tp._id"
              :key="tp._id"
              :selected="tp._id == typeId"
            >{{ tp.name[$i18n.locale] ? tp.name[$i18n.locale] : tp.name['en'] }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-12 bottom-space">
        <label for="examNote">{{ $t("labels.notes") }}</label>
        <textarea id="examNote" class="form-control" v-model="clonedExam.notes"></textarea>
      </div>
      <div class="col-md-12">
        <div class="dropzone bottom-space">
          <h5>
            * {{ $t("labels.examDocUpload") }}
            <span>
              <strong>{{ $t('labels.maxVideoSize') }}:</strong>
              <br />15 Mb
            </span>
            <span>
              <strong>{{ $t('labels.allowedFormats') }}:</strong>
              <br />
              {{ $store.state.allowedFileTypesSimple.toString().split(',').join(', ') }}
            </span>
          </h5>
          <br />
          <input type="file" id="file" ref="file" @change="getFile" />
        </div>
        <div class="row bottom-space" v-if="clonedExam.document && clonedExam.document.originalname">
          <div class="col-md-10">
            <span>
              <strong>{{ $t('labels.name') }}:</strong>
              {{ clonedExam.document.originalname }}
            </span>
            <br />
            <span :class="{red: clonedExam.document.size/1024/1024 > 15}">
              <strong>{{ $t('labels.size') }}:</strong>
              {{ (clonedExam.document.size/1024/1024).toFixed(2) }} Mb
            </span>
            <br />
            <span :class="{red: !$store.state.allowedFileTypes.includes(clonedExam.document.mimetype)}">
              <strong>{{ $t('labels.type') }}:</strong>
              {{ clonedExam.document.mimetype }}
            </span>
          </div>
          <div class="col-md-2">
            <a class="warning p-0" @click.prevent="deleteDocument">
              <i class="fa fa-trash font-medium-3 mr-2"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
  props: {
    exam: {
      type: Object,
      required: true
    },
    examTypes: {
      type: Array,
      required: true
    },
    typeId: {
      type: String
    }
  },
  data() {
    return {
      clonedExam: {},
      clonedExamTypes: [],
    }
  },
  methods: {
    getFile() {
      if  (this.$refs.file.files.length > 0) {
          this.clonedExam.document = this.$refs.file.files[0]
      }
    },
    deleteDocument() {
        this.$refs.file.value = ''
        this.clonedExam.document = {}
    }
  },
  watch: {
    'exam': {
      handler: function(newValue) {
        this.clonedExam = Object.assign({}, newValue)
      },
      deep: true
    },
    'examTypes': {
        handler: function(newValue) {
          if (Object.keys(newValue).length > 0) {
            this.clonedExamTypes = newValue
            if (this.typeId == '' && newValue.length) {
              this.$emit('update:typeId', newValue[0]._id)
            }
          }
        },
      },
  }
}
</script>